export const PAGE_CONFIG = {
  "name": "CommonHeader",
  "data": {
    "subtitle": "-"
  },
  "config": {
    "title": "Forecast",
    "titleCn": "预测",
    "subtitle": "Latest Updated : {{subtitle}} (UTC+0)",
    "subtitleCn": "最新更新 : {{subtitle}} (UTC+0)",
    "customSubTitle": true
  },
  "children": [
    {
      "name": "CommonContantWrap",
      "config": {
        "isHaveNotification": true,
        "notificationPath": "/forecast",
        "logConfig": {
          "typeId": "dashboard_pc_v2",
          "uidType": "game_code",
          "pageId": "206501",
          "pageName": "Forecast",
          "extInfo": "Forecast",
          "pagePath": "/forecast"
        }
      },
      "children": [
        {
          "name": "MetricsCardTitle",
          "className": "",
          "type": "view",
          "style": {},
          "props": {
            "config": {
              "titleEn": "Key Metrics",
              "titleCn": "关键指标",
              "modalTitleEn": "Key Metrics Explanation",
              "modalTitleCn": "关键指标释义",
              "isMetricsExplain": true,
              "metricsWidth": 80,
              "style": {"margin": "0 0 20px 0"},
              "data": [
                {
                  "titleEn": "Lifetime Base Game Units (After Refund)",
                  "titleCn": "累计销量(剔除退款)",
                  "explainEn": "​Current cumulative sales​​, including sales after refund of all editions from the start of pre-order to the update time. The sales data of previous day is updated around 4:00 PM (UTC+8).",
                  "explainCn": "当前累计销量，包含自预售起始日至更新时间的所有版本销售数据(退款后)。UTC+8时区北京时间每天下午4点左右更新前一日销售数据。"
                },
                {
                  "titleEn": "Forecast: M1 Sales Units (After Refund)",
                  "titleCn": "预估: 首月销量(剔除退款)",
                  "explainEn": "Forecasted first-month sales range​​ as of the last update time. ​​This forecast result dynamically refreshes daily as sales increase. The first-month sales covers the period from the start day of pre-order to the 30-th day after full-launch.​ All sales data represents the base game units sold after refund.",
                  "explainCn": "截至预估最后更新时间，对首月销量的预估值范围。该预估值会随着销量的增长而每日动态刷新。首月销量统计范围为，自预售起始日起，至游戏正式上线后30天。销量数据为退款后本体销量口径。"
                },
                {
                  "titleEn": "Forecast: Q1 Sales Units (After Refund)",
                  "titleCn": "预估: 首季销量(剔除退款)",
                  "explainEn": "Forecasted first-quarter sales range​​ as of the last update time. ​​This forecast result dynamically refreshes daily as sales increase. The first-quarter sales covers the period from the start day of pre-order to the 91-th day after full-launch.​ All sales data represents the base game units sold after refund.",
                  "explainCn": "截至预估最后更新时间，对首季销量的预估值范围。该预估值会随着销量的增长而每日动态刷新。首季销量统计范围为，自预售起始日起，至游戏正式上线后91天。销量数据为退款后本体销量口径。"
                },
                {
                  "titleEn": "Forecast: H1 Sales Units (After Refund)",
                  "titleCn": "预估: 首半年销量(剔除退款)",
                  "explainEn": "Forecasted first-half-year sales range​​ as of the last update time. ​​This forecast result dynamically refreshes daily as sales increase. The first-half-year sales covers the period from the start day of pre-order to the 182-th day after full-launch.​ All sales data represents the base game units sold after refund.",
                  "explainCn": "截至预估最后更新时间，对首半年销量的预估值范围。该预估值会随着销量的增长而每日动态刷新。首半年销量统计范围为，自预售起始日起，至游戏正式上线后182天。销量数据为退款后本体销量口径。"
                },
                {
                  "titleEn": "Forecast: Y1 Sales Units (After Refund)",
                  "titleCn": "预估: 首年销量(剔除退款)",
                  "explainEn": "Forecasted first-year sales range​​ as of the last update time. ​​This forecast result dynamically refreshes daily as sales increase. The first-year sales covers the period from the start day of pre-order to the 365-th day after full-launch.​ All sales data represents the base game units sold after refund.",
                  "explainCn": "截至预估最后更新时间，对首年销量的预估值范围。该预估值会随着销量的增长而每日动态刷新。首年销量统计范围为，自预售起始日起，至游戏正式上线后365天。销量数据为退款后本体销量口径。"
                },
                {
                  "titleEn": "Forecast: 2025 Sales Units (After Refund)",
                  "titleCn": "预估: 2025年销量(剔除退款)",
                  "explainEn": "Forecasted 2025 sales range​​ in the 2025 year as of the last update time. ​​This forecast result dynamically refreshes daily as sales increase. The sales in the 2025 covers the period from the start day of pre-order to 31-12-2025.​ All sales data represents the base game units sold after refund.​",
                  "explainCn": "截至预估最后更新时间，对2025年内销量的预估值范围。该预估值会随着销量的增长而每日动态刷新。2025年内销量统计范围为，自预售起始日起，至2025年12月31日。销量数据为退款后本体销量口径。"
                }
              ]
            }
          }
        },
        {
          "name": "ForecastService",
          "props": {
            "api": "/api/v1/dashboard/pc/overview_forecast/card",
            "formatData": ""
          },
          "children": [
            {
              "name": "ForecastCardWrap",
              "className": "",
              "props": {
                "onlyApiMetrics": true,
                "dataKey": 'forecastData',
              },
              "children": [
                {
                  "name": "ForecastMetricCard",
                  "className": "",
                  "style": {
                    "marginTop": "16px"
                  },
                  "props": {
                    "metricKey": "current_sales",
                    "titleEn": "Lifetime Base Game Units (After Refund)",
                    "titleCn": "累计销量(剔除退款)",
                    "tipEn": "​​​​​​​Current cumulative sales​​, including sales after refund of all editions from the start of pre-order to the update time. The sales data of previous day is updated around 4:00 PM (UTC+8).",
                    "tipCn": "当前累计销量，包含自预售起始日至更新时间的所有版本销售数据(退款后)。UTC+8时区北京时间每天下午4点左右更新前一日销售数据。",
                    "formatRule": "intBmk00"
                  }
                },
                {
                  "name": "ForecastMetricCard",
                  "className": "",
                  "style": {
                    "marginTop": "16px"
                  },
                  "props": {
                    "metricKey": "m1_sales_forecast",
                    "titleEn": "Forecast: M1 Sales Units (After Refund)",
                    "titleCn": "预估: 首月销量(剔除退款)",
                    "tipEn": "Forecasted first-month sales range​​ as of the last update time. ​​This forecast result dynamically refreshes daily as sales increase. The first-month sales covers the period from the start day of pre-order to the 30-th day after full-launch.​ All sales data represents the base game units sold after refund.​",
                    "tipCn": "截至预估最后更新时间，对首月销量的预估值范围。该预估值会随着销量的增长而每日动态刷新。首月销量统计范围为，自预售起始日起，至游戏正式上线后30天。销量数据为退款后本体销量口径。",
                    "formatRule": "intBmk00"
                  }
                },
                {
                  "name": "ForecastMetricCard",
                  "className": "",
                  "style": {
                    "marginTop": "16px"
                  },
                  "props": {
                    "metricKey": "q1_sales_forecast",
                    "titleEn": "Forecast: Q1 Sales Units (After Refund)",
                    "titleCn": "预估: 首季销量(剔除退款)",
                    "tipEn": "Forecasted first-quarter sales range​​ as of the last update time. ​​This forecast result dynamically refreshes daily as sales increase. The first-quarter sales covers the period from the start day of pre-order to the 91-th day after full-launch.​ All sales data represents the base game units sold after refund.​​",
                    "tipCn": "截至预估最后更新时间，对首季销量的预估值范围。该预估值会随着销量的增长而每日动态刷新。首季销量统计范围为，自预售起始日起，至游戏正式上线后91天。销量数据为退款后本体销量口径。",
                    "formatRule": "intBmk00"
                  }
                },
                {
                  "name": "ForecastMetricCard",
                  "className": "",
                  "style": {
                    "marginTop": "16px"
                  },
                  "props": {
                    "metricKey": "h1_sales_forecast",
                    "titleEn": "Forecast: H1 Sales Units (After Refund)",
                    "titleCn": "预估: 首半年销量(剔除退款)",
                    "tipEn": "Forecasted first-half-year sales range​​ as of the last update time. ​​This forecast result dynamically refreshes daily as sales increase. The first-half-year sales covers the period from the start day of pre-order to the 182-th day after full-launch.​ All sales data represents the base game units sold after refund.​​​​",
                    "tipCn": "截至预估最后更新时间，对首半年销量的预估值范围。该预估值会随着销量的增长而每日动态刷新。首半年销量统计范围为，自预售起始日起，至游戏正式上线后182天。销量数据为退款后本体销量口径。",
                    "formatRule": "intBmk00"
                  }
                },
                {
                  "name": "ForecastMetricCard",
                  "className": "",
                  "style": {
                    "marginTop": "16px"
                  },
                  "props": {
                    "metricKey": "y1_sales_forecast",
                    "titleEn": "Forecast: Y1 Sales Units (After Refund)",
                    "titleCn": "预估: 首年销量(剔除退款)",
                    "tipEn": "Forecasted first-year sales range​​ as of the last update time. ​​This forecast result dynamically refreshes daily as sales increase. The first-year sales covers the period from the start day of pre-order to the 365-th day after full-launch.​ All sales data represents the base game units sold after refund.​",
                    "tipCn": "截至预估最后更新时间，对首年销量的预估值范围。该预估值会随着销量的增长而每日动态刷新。首年销量统计范围为，自预售起始日起，至游戏正式上线后365天。销量数据为退款后本体销量口径。",
                    "formatRule": "intBmk00"
                  }
                },
                {
                  "name": "ForecastMetricCard",
                  "className": "",
                  "style": {
                    "marginTop": "16px"
                  },
                  "props": {
                    "metricKey": "2025_sales_forecast",
                    "titleEn": "Forecast: 2025 Sales Units (After Refund)",
                    "titleCn": "预估: 2025年销量(剔除退款)",
                    "tipEn": "Forecasted 2025 sales range​​ in the 2025 year as of the last update time. ​​This forecast result dynamically refreshes daily as sales increase. The sales in the 2025 covers the period from the start day of pre-order to 31-12-2025.​ All sales data represents the base game units sold after refund.​​",
                    "tipCn": "截至预估最后更新时间，对2025年内销量的预估值范围。该预估值会随着销量的增长而每日动态刷新。2025年内销量统计范围为，自预售起始日起，至2025年12月31日。销量数据为退款后本体销量口径。​",
                    "formatRule": "intBmk00"
                  }
                }
              ]
            }
          ]
        },
        {
          "name": "ForecastService",
          "className": "",
          "type": "view",
          "props": {
            "api": "/api/v1/dashboard/pc/overview_forecast/breakdown/trend/selector",
            "dataKey": "competitorSelector",
          },
          "children": [
            {
              "name": "ForecastService",
              "className": "",
              "type": "view",
              "style": {"marginTop": "20px"},
              "props": {
                "api": "/api/v1/dashboard/pc/overview_forecast/breakdown/trend",
                "formatDataFunc": "trendFormatData"
              },
              "data": {"competitor_list": []},
              "children": [
                {
                  "name": "MarkAreaTrend",
                  "props": {
                    "titleEn": "Dune Sale Units (After Refund) In Y1",
                    "titleCn": "Dune首年销量(剔除退款)",
                    "subTitleEn": "Date: {{date}}   Lifetime Base Game Units (After Refund): {{lastData}}",
                    "subTitleCn": "日期: {{date}}   累计销量(剔除退款): {{lastData}}",
                    "downloadFileTitleEn": "Dune Y1 Sales Data",
                    "downloadFileTitleCn": "Dune首年销量数据",
                    "selectorKey": "competitorSelector",
                    "dataKey": "forecastData",
                    "initialCompetitor": ["c00002416", "c00002058"],
                    "formatRule": "intBmk00",
                    "downloadFormatRule": "int",
                    "tableHeight": 320,
                    "maxSelect": 5,
                    "defaultTab": "forecast",
                    "dateNameMap": {
                      "M1": "首月",
                      "Q1": "首季",
                      "H1": "首半年",
                      "Y1": "首年"
                    },
                    "tabList": [
                      {
                        "value": "forecast",
                        "nameEn": "Forecast",
                        "nameCn": "预测",
                        "componentMetrics": [
                          {
                            "enName": "Lower Forecast",
                            "cnName": "低预测",
                            "metricKey": "lower_forecast",
                            "color": "#AD9EFF",
                            "width": 80,
                            "formatRule": "intBmk00"
                          },
                          {
                            "enName": "Upper Forecast",
                            "cnName": "高预测",
                            "metricKey": "upper_forecast",
                            "color": "#5E54CC",
                            "width": 80,
                            "formatRule": "intBmk00"
                          },
                          {
                            "enName": "Lifetime Base Game Units (After Refund)",
                            "cnName": "累计销量(剔除退款)",
                            "metricKey": "current_sales",
                            "color": "#69D19C",
                            "width": 120,
                            "formatRule": "intBmk00"
                          }
                        ]
                      },
                      {
                        "value": "competitor",
                        "nameEn": "Competitor",
                        "nameCn": "竞品",
                        "componentMetrics": [
                          {
                            "enName": "Lifetime Base Game Units (After Refund)",
                            "cnName": "累计销量(剔除退款)",
                            "metricKey": "current_sales",
                            "color": "#69D19C",
                            "width": 120,
                            "formatRule": "intBmk00"
                          }
                        ]
                      }
                    ],
                    "tooltipConfig": {
                      "unitEn": "Units",
                      "unitCn": "销量"
                    },
                  }
                },
              ]
            },
          ]
        },
        {
          "name": "ForecastService",
          "style": {"marginTop": "20px"},
          "props": {
            "api": "/api/v1/dashboard/pc/overview_forecast/breakdown/competitors",
            "extraParams": {
              "logical_flag": "include_forecast_game"
            },
            "formatData": ""
          },
          "children": [
            {
              "name": "UnitSalesBarChart",
              "props": {
                "titleEn": "Unit Sales In Periods",
                "titleCn": "分时段销量",
                "tooltipConfig": {
                  "valueNameEn": "Sales",
                  "valueNameCn": "销量"
                },
                "dataKey": 'forecastData',
                "formatRule": "intBmk00",
                "tableColumnsMap": {
                  "game_name": {
                    "nameEn": "Game",
                    "nameCn": "游戏",
                    align: 'left',
                    enWidth: 100,
                    valuePath: "{{game_name}}"
                  },
                  "current": {
                    nameEn: "Day{{diffDay}} (After Release)",
                    nameCn: "D{{diffDay}} (上线后)",
                    align: 'right',
                    enWidth: 80,
                    formatter: 'intBmk00',
                    valuePath: "{{values.current}}"
                  },
                  "current_m1": {
                    "nameEn": "M1",
                    "nameCn": "M1",
                    align: 'right',
                    enWidth: 80,
                    formatter: 'intBmk00',
                    valuePath: "{{values.current_m1}}"
                  },
                  "current_q1": {
                    "nameEn": "Q1",
                    "nameCn": "Q1",
                    align: 'right',
                    enWidth: 80,
                    formatter: 'intBmk00',
                    valuePath: "{{values.current_q1}}"
                  },
                  "current_h1": {
                    "nameEn": "H1",
                    "nameCn": "H1",
                    align: 'right',
                    enWidth: 80,
                    formatter: 'intBmk00',
                    valuePath: "{{values.current_h1}}"
                  },
                  "current_y1": {
                    "nameEn": "Y1",
                    "nameCn": "Y1",
                    align: 'right',
                    enWidth: 80,
                    formatter: 'intBmk00',
                    valuePath: "{{values.current_y1}}"
                  },
                  "m1_y1": {
                    "nameEn": "M1~Y1",
                    "nameCn": "M1~Y1",
                    align: 'right',
                    enWidth: 80,
                    formatter: 'intBmk00',
                    valuePath: "{{values.m1_y1}}"
                  },
                  "q1_y1": {
                    "nameEn": "Q1~Y1",
                    "nameCn": "Q1~Y1",
                    align: 'right',
                    enWidth: 80,
                    formatter: 'intBmk00',
                    valuePath: "{{values.q1_y1}}"
                  },
                  "h1_y1": {
                    "nameEn": "H1~Y1",
                    "nameCn": "H1~Y1",
                    align: 'right',
                    enWidth: 80,
                    formatter: 'intBmk00',
                    valuePath: "{{values.h1_y1}}"
                  }
                },
              }
            }
          ]
        }
      ]
    }
  ]
};